import React from 'react';
import { ModalWrapper } from './ModalWrapper';
import { MODAL_WIDTHS } from '../../constants/popupStyles';

interface PDFViewerModalProps {
    isOpen: boolean;
    onClose: () => void;
    pdfData: {
        name: string;
        type: string;
        sizeBytes: number;
        base64Data: string;
    } | null;
}

export const PDFViewerModal: React.FC<PDFViewerModalProps> = ({
    isOpen,
    onClose,
    pdfData,
}) => {
    if (!isOpen || !pdfData) return null;

    // Create data URL for the PDF
    const pdfDataUrl = `data:${pdfData.type};base64,${pdfData.base64Data}`;

    return (
        <ModalWrapper modalId="PDFViewerModal"
            isOpen={isOpen}
            onClose={onClose}
            title={pdfData.name}
            width={MODAL_WIDTHS.pdfViewer}
            compactHeader={true}
        >
            {/* PDF viewer */}
            <div className="flex-1 overflow-auto bg-[#EBF5F5] p-4">
                <div className="flex justify-center min-h-full">
                    <iframe
                        src={pdfDataUrl}
                        className="bg-white shadow-lg"
                        style={{
                            width: '100%',
                            height: '600px',
                            minHeight: '400px',
                            border: 'none',
                        }}
                        title="PDF Viewer"
                    />
                </div>
            </div>
        </ModalWrapper>
    );
};
